import { Auth0Provider } from "@auth0/auth0-react"
import { useCallback } from "react"
import { useNavigate } from "react-router-dom"

type Auth0ProviderWithNavigateProps = {
  children: React.ReactNode
}

type AppState = {
  returnTo?: string
}

const domain = import.meta.env.VITE_AUTH0_DOMAIN!
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID!
const audience = import.meta.env.VITE_AUTH0_AUDIENCE

export default function Auth0ProviderWithNavigate({ children }: Auth0ProviderWithNavigateProps) {
  const navigate = useNavigate()
  const redirectUri = `${window.location.origin}/login/callback`

  const authorizationParams: Record<string, string> = {
    redirect_uri: redirectUri,
    scope: "openid profile email",
  }

  if (audience) {
    authorizationParams.audience = audience
  }

  const onRedirectCallback = useCallback(
    (appState?: AppState) => {
      const target =
        appState?.returnTo ?? `${window.location.pathname}${window.location.search}`
      navigate(target, { replace: true })
    },
    [navigate]
  )

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={authorizationParams}
      cacheLocation="memory"
      useRefreshTokens
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}
